"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Link = _interopRequireDefault(require("@insided/destination/icons/Link"));

var _Check = _interopRequireDefault(require("@insided/shared/icons/Check"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ICON_SIZE = 20;

var DropdownItemEditPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownItemEditPanel, _Component);

  var _super = _createSuper(DropdownItemEditPanel);

  function DropdownItemEditPanel() {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownItemEditPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "titleInputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "urlInputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSave", function () {
      var _this$titleInputRef$v, _this$titleInputRef, _this$urlInputRef$val, _this$urlInputRef;

      _this.props.onSave((_this$titleInputRef$v = (_this$titleInputRef = _this.titleInputRef) === null || _this$titleInputRef === void 0 ? void 0 : _this$titleInputRef.value) !== null && _this$titleInputRef$v !== void 0 ? _this$titleInputRef$v : '', (_this$urlInputRef$val = (_this$urlInputRef = _this.urlInputRef) === null || _this$urlInputRef === void 0 ? void 0 : _this$urlInputRef.value) !== null && _this$urlInputRef$val !== void 0 ? _this$urlInputRef$val : '');
    });
    return _this;
  }

  (0, _createClass2.default)(DropdownItemEditPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          url = _this$props.url,
          onCancel = _this$props.onCancel;
      return (0, _preact.h)("div", {
        className: "dropdown-settings__edit-panel"
      }, (0, _preact.h)("div", {
        className: "dropdown-settings__edit-header"
      }, (0, _preact.h)("span", {
        className: "dropdown-settings__edit-title"
      }, "Edit Link"), (0, _preact.h)("div", {
        className: "dropdown-settings__edit-actions"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "dropdown-settings__edit-action-btn",
        onClick: this.handleSave,
        "aria-label": "Save"
      }, (0, _preact.h)(_Check.default, {
        width: ICON_SIZE,
        height: ICON_SIZE
      })), (0, _preact.h)("button", {
        type: "button",
        className: "dropdown-settings__edit-action-btn",
        onClick: onCancel,
        "aria-label": "Cancel"
      }, (0, _preact.h)(_Close.default, {
        width: ICON_SIZE,
        height: ICON_SIZE
      })))), (0, _preact.h)("div", {
        className: "dropdown-settings__edit-body"
      }, (0, _preact.h)("div", {
        className: "dropdown-settings__edit-row"
      }, (0, _preact.h)("span", {
        className: "dropdown-settings__edit-icon"
      }, "Tr"), (0, _preact.h)("input", {
        type: "text",
        className: "dropdown-settings__edit-input",
        ref: function ref(_ref) {
          _this2.titleInputRef = _ref;
          if (_ref) _ref.value = title;
        },
        placeholder: "Title"
      })), (0, _preact.h)("div", {
        className: "dropdown-settings__edit-row"
      }, (0, _preact.h)(_Link.default, {
        width: ICON_SIZE,
        height: ICON_SIZE
      }), (0, _preact.h)("input", {
        type: "text",
        className: "dropdown-settings__edit-input",
        ref: function ref(_ref2) {
          _this2.urlInputRef = _ref2;
          if (_ref2) _ref2.value = url;
        },
        placeholder: "URL"
      }))));
    }
  }]);
  return DropdownItemEditPanel;
}(_preact.Component);

var _default = DropdownItemEditPanel;
exports.default = _default;